export default __webpack_public_path__ + "static/media/grafema_clivitalbio_07.b47839bd.jpg";